import styled from "styled-components";
import ExpandMore from "@mui/icons-material/ExpandMore";

export const Title = styled.h6`
	font-weight: bold;
`;

export const AccordionTitle = styled.div`
	color: black;
	font-weight: bold;
`;

export const TitleGrid = styled.div`
	font-weight: bold;
	color: #000;
`;

export const IconExpandMore = styled(ExpandMore)`
	&&& {
		color: ${({ theme }) => theme.pantone2726C};
		font-size: 30px;
	}
`;

export const Spinner = styled.div`
	border: 3px solid rgba(0, 0, 0, 0.1);
	border-left-color: ${({ theme }) => theme.pantone2726C};
	border-radius: 50%;
	width: 20px;
	height: 20px;
	animation: spin 1s linear infinite;
	margin: 0 10px;

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;
